export default "__VITE_ASSET__Cwa64Plx__"